import { normalizeSkillSetForComparison } from "./lib/skill-set-comparison"

export function buildBaseComponent(task = {}, skillsIndex = {}) {
    if (!task?.id) return null

    return {
        id: task.id,
        componentRef: task.id,
        componentVersion: task.version ?? 1,
        title: task.heading,
        classification: task.classification,
        content: task.actionsHtml ?? "",
        note: task.notesHtml ?? "",
        authorsNotesHtml: task.authorsNotesHtml ?? "",
        frequency: task.frequency,
        // Component library stores skillSet as a label/code; schedules expect the CoreSkillingID.
        skillSet: normalizeSkillSetForComparison(task.skillSet, skillsIndex),
        minutes: task.timing?.minutes ?? task.minutes,
    }
}

export function selectComponentVersion({ component, history = [], version } = {}) {
    const selectedVersion = Number(version)
    if (!selectedVersion) return null
    if (component?.version === selectedVersion) return component

    return history.find((item) => item?.version === selectedVersion)?.snapshot ?? null
}
